import * as React from "react";
import { createUseStyles } from "react-jss";
import FacetMultiToggle from "@warda/library-ui/core/Filter/FacetMultiToggle/FacetMultiToggle";
import { SearchScope } from "@warda/library-ui/interfaces";
const useStyles = createUseStyles({
    buttons: {
        minHeight: 30,
        minWitdh: 250,
        maxWidth: 250,
    },
});
const ScopeSwitch = ({ value, onChange }) => {
    const classes = useStyles();
    const actionsConditions = React.useMemo(() => [
        {
            id: SearchScope.ENTIRE_HIERARCHY,
            icon: "language",
            selected: SearchScope.ENTIRE_HIERARCHY === value,
            tooltip: "Search in the entire area",
        },
        {
            id: SearchScope.CURRENT_AND_SUBFOLDERS,
            icon: "folder_tree",
            selected: SearchScope.CURRENT_AND_SUBFOLDERS === value,
            tooltip: "Search in this folder and subfolders",
        },
        {
            id: SearchScope.CURRENT_ONLY,
            icon: "folder_open",
            selected: SearchScope.CURRENT_ONLY === value,
            tooltip: "Search in this folder",
        },
    ], [value]);
    return (React.createElement(FacetMultiToggle, { btnsClassName: classes.buttons, actions: actionsConditions, onChange: onChange }));
};
export default ScopeSwitch;
